import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { TenantId } from '../../../environments/environments.types';
import {
  ForgotPasswordDialogComponent,
  ForgotPasswordSuccessDialogComponent,
  InviteDialogComponent,
  InviteErrorDialogComponent,
  InviteSuccessDialogComponent,
} from '../../components';
import { DialogResult } from '../../types';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  readonly enableMbr: boolean;

  constructor(
    private keycloak: KeycloakService,
    private modalService: BsModalService
  ) {
    this.enableMbr = environment.mbr?.enabled ?? false;
  }

  login(): void {
    // Keycloak does not use "location.assign" but rather "location.replace"; so it does not itself create a history
    //  entry to which one could navigate back. For this reason, we're creating one manually.
    window.history.pushState({}, 'Landing Page');
    this.keycloak.login({
      redirectUri: `${window.location.origin}/home`,
    });
  }

  inviteDialog(): void {
    const modalRef: BsModalRef<InviteDialogComponent> =
      this.modalService.show(InviteDialogComponent, {
        class: 'modal-md',
      });

    modalRef.onHidden?.subscribe(() => {
      const result = modalRef.content?.result;
      this.inviteResponse(result as DialogResult);
    });
  }

  forgotPasswordDialog(): void {
    const modalRef: BsModalRef<ForgotPasswordDialogComponent> =
      this.modalService.show(
        ForgotPasswordDialogComponent,
        {
          class: 'modal-sm',
        }
      );

    modalRef.onHidden?.subscribe(() => {
      const result = modalRef.content?.result;
      this.forgotPasswordResponse(result as DialogResult);
    });
  }

  get tenant(): TenantId {
    return environment.tenant;
  }

  private inviteResponse(result: DialogResult): void {
    if (result?.success === true) {
      this.modalService.show(InviteSuccessDialogComponent, {
        class: 'modal-sm',
      });
    } else if (result?.success === false) {
      this.modalService.show(InviteErrorDialogComponent, {
        class: 'modal-sm',
      });
    }
  }

  private forgotPasswordResponse(
    result: DialogResult
  ): void {
    if (result?.success === true) {
      this.modalService.show(
        ForgotPasswordSuccessDialogComponent,
        {
          class: 'modal-sm',
        }
      );
    }
  }
}
